import authService from 'services/authService'
import { LOGIN, LOGOUT, AUTH_REQUEST, AUTH_SUCCESS, AUTH_ERROR, CHECK_AUTH, RELOAD_USER } from './actions.type'
import JwtService from '@/services/jwtService'

export const state = {
  status: '',
  token: '',
  user: {}
}

export const actions = {
  async [LOGIN] (context, user) {
    context.commit(AUTH_REQUEST)

    const siret = user.username

    return new Promise((resolve, reject) => {
      authService.login(user)
        .then(resp => {
          const token = resp.data.token

          // Décode le JWT (Base64 vers JsonObject) + résolution d'un problème d'encodage UTF-8
          const decodedJwt = JSON.parse(decodeURIComponent(atob(resp.data.token.split('.')[1]).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
          }).join('')))

          const user = {
            businessName: decodedJwt.sub,
            email: decodedJwt.email,
            siret,
            firstConnexion: resp.data.defaultPassword // decodedJwt.firstConnexion
          }

          context.commit(AUTH_SUCCESS, { token, user })
          resolve(user)
        })
        .catch(err => {
          context.commit(AUTH_ERROR)
          reject(err)
        })
    })
  },
  async [LOGOUT] ({ commit }) {
    return new Promise(resolve => {
      commit(LOGOUT)
      resolve()
    })
  },
  async [CHECK_AUTH] (context) {
    const token = JwtService.getToken()
    if (token) {
      if (!context.state.user.siret) {
        context.commit(RELOAD_USER, token)
      }
    } else {
      context.commit(LOGOUT)
    }
  }
}

export const mutations = {
  [AUTH_REQUEST] (state) {
    state.status = 'loading'
  },
  [AUTH_SUCCESS] (state, { token, user }) {
    state.status = 'success'
    state.token = token
    state.user = user
    JwtService.saveToken(token)
    JwtService.saveUser(user)
  },
  [AUTH_ERROR] (state) {
    state.status = 'error'
  },
  [LOGOUT] (state) {
    state.status = ''
    state.token = ''
    state.user = {}
    JwtService.destroyToken()
    JwtService.destroyUser()
  },
  [RELOAD_USER] (state, token) {
    state.user = JwtService.getUser()
    state.token = token
  }
}

const getters = {
  token: state => state.token,
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  user: state => state.user
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/auth.module.js